import { ImResponse, resolve, storeHomeClient, storeHomeNVClient } from '.';

export interface ITokopediaAppsReq {
  appId: string;
  clientId: string;
  clientSecret: string;
}
export function tokopediaApps(body: ITokopediaAppsReq) {
  return resolve<any>(storeHomeClient.post('/admin/tokopedia_apps', body));
}

export function storeTokopediaApp(storeId: number) {
  return resolve<ITokopediaAppsReq>(
    storeHomeClient.get('/admin/store/tokopedia_app', {
      params: {
        storeId,
      },
    }),
  );
}

export interface ReportAuthStatusBody {
  storeId: string;
  authStatus: 'AUTH' | 'GRAY_UN_AUTH';
}

/**
 * 灰口登录上报授权状态
 *  登录成功 authStatus = AUTH 登录失败为 GRAY_UN_AUTH
 */
export function reportAuthStatus(body: ReportAuthStatusBody) {
  return resolve<ImResponse>(storeHomeNVClient.post('/tokopedia/auth_status_report', body));
}

export interface UpdateGrayAccountBody {
  storeId: number;
  account: string;
}

/**
 * 灰口保存账号密码
 */
export function updateGrayAccount(body: UpdateGrayAccountBody) {
  return resolve<ImResponse>(storeHomeNVClient.post('/gray/account/save_or_update', body));
}

export enum TokopediaStoreType {
  旗舰店 = 0,
  会员店 = 1,
}
export interface AuthByDomainBody {
  domain: string;
  storeType: TokopediaStoreType;
  storeName: string;
}

export const authByDomain = (body: AuthByDomainBody) => {
  return resolve<ImResponse<any>>(storeHomeNVClient.post('/tokopedia/auth_by_domain', body));
};
